import React from "react";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        padding: "2px",
        backgroundColor: "#FFFFFF",
        color: "rgba(0,0,0,0.7)",
        minWidth: 400,
        fontSize: theme.typography.pxToRem(12),
        borderRadius: "4px",
        border: "1px solid #dadde9",
    },
}));

export default HtmlTooltip;
